var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable no-var */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");
var _ = require("underscore");

var Changeable = require("../mixins/changeable.jsx");
var EditorJsonify = require("../mixins/editor-jsonify.jsx");

var InfoTip = require("../components/info-tip.jsx");
var BlurInput = require("react-components/blur-input.jsx");

var KA_VIDEO_URL = /khanacademy\.org\/.*\/v\/(.*)$/;

/**
 * Turns Khan Academy URLs into the KA slugs, if possible. Any other URLs are
 * returned unchanged.
 */
function getSlugFromUrl(url) {
    var match = KA_VIDEO_URL.exec(url);
    if (match) {
        return match[1];
    }
    return url;
}

/**
 * This is the main editor for this widget, to specify all the options.
 */
var VideoEditor = React.createClass({
    displayName: "VideoEditor",

    propTypes: _extends({}, Changeable.propTypes, {
        location: React.PropTypes.string,
        onChange: React.PropTypes.func
    }),

    getDefaultProps: function getDefaultProps() {
        return {
            location: ""
        };
    },

    _handleUrlChange: function _handleUrlChange(url) {
        this.props.onChange({ location: getSlugFromUrl(url) });
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },
    serialize: function serialize() {
        return EditorJsonify.serialize.call(this);
    },


    render: function render() {
        return React.createElement(
            "div",
            null,
            React.createElement(
                "label",
                null,
                "URL or KA Video Slug:",
                " ",
                React.createElement(BlurInput, {
                    name: "location",
                    value: this.props.location,
                    style: { width: 290 },
                    onChange: this._handleUrlChange
                }),
                React.createElement(
                    InfoTip,
                    null,
                    "You can paste any URL here. KA video URLs will be converted to just the slug."
                )
            )
        );
    }
});

module.exports = VideoEditor;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/video-editor.jsx
 ** module id = 157
 ** module chunks = 0 1
 **/